import React, { useState, useEffect } from 'react'
import Nav from '../Nav'
import axios from '../../api/api'
import { Link } from 'react-router-dom'
import { FaPlay } from "react-icons/fa";
import { MdOutlineBlock } from 'react-icons/md';

const Comedy = () => {

  const [comedy,setComedy] = useState([])

  useEffect(() => {  
    // get all comedy movies
    const getAllComedy = async () => {
      const response = await axios.get('/api/v3/contents/Approved/Comedy');
      setComedy(response.data.contents);
    };
    getAllComedy();
  }, []);

  return (
    <div>
      <Nav/>
      <div className="mx-auto p-4 lg:container">
        <h1 className="text-3xl px-4">Comedy</h1>
        <section className='min-h-[40em]'>
          {comedy.length > 0 ? (
            <div className="grid grid-cols-2 gap-4 md:grid-cols-4 lg:grid-cols-8 p-4">
              {comedy.map((comedy) => (
                <div key={comedy._id} >
                  <Link to={`/viewer/viewtrailer/${comedy._id}`}>
                    <div className="containe">
                      <img width={600} height={400}  src={`https://naijaserver.cleverapps.io/api/v3/image/${comedy.coverPhoto}`} className="image rounded-lg h-64" alt="" />
                      <div className="middle bg-blue-600 rounded-full p-4 flex items-center justify-center h-14 w-14">
                        <span className="text-white p-4 text-xl"><FaPlay /></span>
                      </div>
                      <div className='p-2 text-center'>
                        <h4>{comedy.movieName}</h4>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          ) : (
            <div className='bg-[#EEF1FF] h-[25em] grid place-items-center'>
              <div className='grid place-items-center'>
                <h2><MdOutlineBlock /></h2>
                <h4>No Movies</h4>
              </div>
            </div>
          )}
        </section>
      </div>
    </div>
  )
}

export default Comedy
